import {create} from "apisauce";
import qs from "qs";
import {v4} from "uuid";

import {makeAuthorizationHeader} from "../../utils/token";
import {responseTransform} from "./helpers";
import {Config} from "./consts";

let config: Config = null;

export const http = create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    Accept: "application/json",
  },
  paramsSerializer: params =>
    qs.stringify(params, {
      arrayFormat: "repeat",
      skipNulls: true,
    }),
});

export function configureApiClient(cfg: Config) {
  config = cfg;
}

http.addAsyncRequestTransform(async request => {
  request.headers = request.headers || {};
  request.headers["X-Correlation-ID"] = v4();

  if (config) {
    const token = await config.getToken();

    if (token) {
      request.headers.Authorization =
        request.headers.Authorization ?? makeAuthorizationHeader(token);
    }
  }
});

http.addResponseTransform(response => responseTransform(response, config));
